import { render } from "./DocumentSearchResults.vue?vue&type=template&id=79e889c3"
import script from "./DocumentSearchResults.vue?vue&type=script&lang=js"
export * from "./DocumentSearchResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__